import React, { memo } from "react";
import classnames from "classnames";
import { twMerge } from "tailwind-merge";
import { PREFIX } from "@zmedia/bm-common/constants";
import { Element } from "../base";

interface IProps {
    className?: string;
    children: React.ReactNode;
    active?: boolean;
}

function NavbarMenu(props: IProps) {
    const { children, className, active, ...rest } = props;

    return (
        <Element
            {...rest}
            renderAs="ul"
            className={classnames(
                twMerge(`${PREFIX}-navbar-menu`, "block", className),
                {
                    ["is-active"]: active,
                }
            )}
        >
            {children}
        </Element>
    );
}

export default memo(NavbarMenu);
